import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { SidebarModule } from '../constants/Enums';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { KompanStore } from '../Kompan/KompanStore';
import { ReadOnly } from '../constants/Enums';
import { ClickButton } from './ClickButton';
import { CoreTooltip } from './CoreTooltip';
import { KompanBase, KompanInterface, KompanHelper, VariantObject } from '../Kompan';

interface TopBarState {
    extraButtons: boolean;
    loadedProjectName: string;
    price: string | null;
    variant: string | null;
    readonly: ReadOnly;
}

interface TopBarProps {
    layoutType: LayoutType;
    sidebar: SidebarModule;
    sidebarOrientation: string;
    elementsInView: boolean;
    userLanguage: string;
}

export class TopBar extends BaseComponent<TopBarProps, TopBarState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.addStoreListener(KompanStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null  {
        if (this.state) {
            let cssClass: string = 'topbar-container';
            if (this.props.sidebarOrientation !== 'right') {
                cssClass += ' on-right-side';
            }
            const user: Array<string> = [];
            if (KompanBase.openedByQuoteIt) {
                if (KompanBase.Configuration.PCuser) {
                    user.push(KompanBase.Configuration.PCuser);
                }
                if (KompanBase.Configuration.CountryCode) {
                    user.push(KompanBase.Configuration.CountryCode);
                }
            }
            return (
                <div className={cssClass}>
                    {this.getLabel()}
                    <div className="pcon-login-bar">
                        {user.join(' / ')}
                    </div>
                    <div className="custom-topbar-right">
                        {KompanBase.openedByQuoteIt &&
                            <ClickButton
                                className="custom-button icon-save"
                                callback={this.onSave}
                                disabled={this.state.readonly !== ReadOnly.Disabled}
                            >
                                <CoreTooltip config={{ label: 'Save new Variant', position: 'bottom' }} />
                            </ClickButton>}
                        {KompanBase.openedByQuoteIt &&
                            <ClickButton
                                className="custom-button icon-close"
                                callback={this.onClose}
                            >
                                <CoreTooltip config={{ label: 'Close', position: 'bottom' }} />
                            </ClickButton>}
                    </div>

                </div>
            );
        }
        return null;
    }

    protected onChange = (): void => {
        const variant: VariantObject = KompanStore.getState().variant as VariantObject;
        const readOnly: ReadOnly = KompanStore.getState().readOnly as ReadOnly;
        this.setState({
            extraButtons: ViewSettingsStore.getState().extraButtons,
            loadedProjectName: ProjectManagerStore.getCurrentProjectName(''),
            price: KompanHelper.getFormattedPrice(),
            variant: variant && variant.variantno ? variant.variantno : null,
            readonly: readOnly ? readOnly : ReadOnly.Disabled
        });
    };

    protected onLabelClick = (): void => {
        /* disabled for now
        if (ProjectManagerStore.getCurrentProject() != null) {
            DialogActions.showProjectNameDialog(this.state.loadedProjectName).then(
                (newName: string) => {ProjectManagerActions.setCurrentProjectName(newName); }
            );
        }
        */
    };

    protected getLabel = (): JSX.Element => {
        let className: string = 'toolbar-label';
        if (
            (this.props.sidebar == null)
        ) {
            className += ' next-to-hamburger';
        }

        const title: Array<string> = [];
        if (KompanBase.openedByQuoteIt) {
            if (this.state.variant) {
                title.push(this.state.variant);
            }
            if (this.state.price) {
                title.push(this.state.price);
            }
        }

        return (
            <div key="toolbar-label" className={className + ' toolbar-label-product'}>
                <span>{title.join(' / ')}</span>
            </div>
        );
    };

    protected onSave = (): void => {
        ViewSettingsActions.withLock<void>(async (): Promise<void> => {
            await KompanInterface.createVariant();
        });
    };

    protected onClose = (): void => {
        KompanInterface.closeConfigurator();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TopBar.tsx